module.exports = {
      id: "twittercolorround-usage",
      viewBox: "0 0 30 30",
      url: __webpack_public_path__ + "svg-sprite-fa9bd75c1e834befd19aa957a85e34e1.svg#twittercolorround",
      toString: function () {
        return this.url;
      }
    }